export enum NotifierTypes {
  CUSTOM = 'Custom Notifier',
  WARNING = 'Warning Notifier',
  SUCCESS = 'SuccessState',
  ERROR = 'ErrorState',
  INFO = 'General',
  NOTIFYWARNING = 'NotifyWarning'
}

export enum WEBVIEW_NOTIFIER_TYPES {
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info',
  WARNING = 'warning'
}
